import { combineReducers } from "redux";

const generateInteriorDesign = (state = {}, action) => {
    switch (action.type) {
        case "GENERATE_INTERIOR_DESIGN_SUCCESS":
            return {
                isLoading: false,
                isError: false,
                isSuccess: true,
                generatedImage: action.payload.image,
                uuid: action.payload.uuid,
            };
        case "CLEAR_GENERATED_INTERIOR_DESIGN":
            return {};
        default:
            return state;
    }
};

const fetchUserInteriorDesigns = (state = {}, action) => {
    switch (action.type) {
        case "FETCH_USER_INTERIOR_DESIGNS_SUCCESS":
            state[action.key] = {
                isLoading: false,
                isError: false,
                isSuccess: true,
                searchInteriorDesigns: action.payload.searchResult,
                searchKey: action.payload.searchKey,
                totalSearchInteriorDesigns: action.payload.totalSearchResult,
            };
        default:
            return state;
    }
};

export default combineReducers({
    generateInteriorDesign,
    fetchUserInteriorDesigns,
});
